import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * "This cart belongs to booking #301." Set from the agenda, read by the cart.
 * While active, the cart's normal checkout is replaced by "save to booking":
 * no direct sale is ever created from a booking's products, and money only
 * enters through the agenda (abonar). Persisted so an F5 mid-selection keeps it.
 */
export type ActiveBooking = {
  bookingId: number
  orderId: string
  /** "Laura · 14 feb 10:00" — what the banner shows */
  label: string
  /** YYYY-MM-DD of the delivery, so the agenda can land on that day when we return */
  date: string
  /** orders.version at the time the context started; the save carries it (optimistic lock) */
  version: number
  /** Where "save to booking" returns: the pedidos agenda by default, the citas page for a cita. */
  returnTo?: '/store/pos/bookings' | '/store/pos/appointments'
}

export const useBookingContextStore = defineStore('bookingContext', () => {
  const active = ref<ActiveBooking | null>(null)

  function start(b: ActiveBooking) {
    active.value = b
  }

  function clear() {
    active.value = null
  }

  /** Re-sync the optimistic-lock version after the order was edited elsewhere. */
  function setVersion(version: number) {
    if (active.value) active.value = { ...active.value, version }
  }

  return { active, start, clear, setVersion }
}, {
  persist: {
    key: 'booking-context',
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    paths: ['active'],
  },
})
